import { gql } from '@apollo/client';
import { COORDINATES_FIELDS, MEDIA_FIELDS } from './common';

const TEXT_ENGRAVING_FIELDS = gql`
  fragment TextEngravingFields on TextEngraving {
    fontId
    fontSize
    lineSpacing
    text
  }
`;

const SYMBOL_ENGRAVING_FIELDS = gql`
  fragment SymbolEngravingFields on SymbolEngraving {
    symbolId
    scalingFactor
  }
`;

const VECTOR_ENGRAVING_FIELDS = gql`
  ${MEDIA_FIELDS}
  fragment VectorEngravingFields on VectorEngraving {
    vector {
      ...MediaFields
    }
    scalingFactor
  }
`;

const BITMAP_ENGRAVING_FIELDS = gql`
  ${MEDIA_FIELDS}
  fragment BitmapEngravingFields on BitmapEngraving {
    image {
      ...MediaFields
    }
    scalingFactor
  }
`;

export const ENGRAVING_FIELDS = gql`
  ${COORDINATES_FIELDS}
  ${TEXT_ENGRAVING_FIELDS}
  ${SYMBOL_ENGRAVING_FIELDS}
  ${VECTOR_ENGRAVING_FIELDS}
  ${BITMAP_ENGRAVING_FIELDS}
  fragment EngravingFields on Engraving {
    id
    editableAreaId
    position {
      ...CoordinatesFields
    }
    alignment
    type
    text {
      ...TextEngravingFields
    }
    symbol {
      ...SymbolEngravingFields
    }
    vector {
      ...VectorEngravingFields
    }
    bitmap {
      ...BitmapEngravingFields
    }
  }
`;
